// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu-module--menu-container--b5254","menuSlide":"menu-module--menu-slide--63ea3"};